import {ruRU} from '@mui/material/locale';
import {adminReportTranslationsRu} from 'modules/admin/report/translations/AdminReportTranslationsRu';
import {fieldsTranslationsRu} from 'modules/fields/translations/FieldsTranslationRu';
import {ruReportTranslations} from 'modules/report/translations/RuReportTranslations';
import ruMessages from '../locales/ru_RU.json';

const RuLang = {
  messages: {
    ...ruMessages,
    ...ruReportTranslations,
    ...adminReportTranslationsRu,
    ...fieldsTranslationsRu,
  },
  muiLocale: ruRU,
  locale: 'ru-RU',
};
export default RuLang;
